import _isBoolean from 'lodash/isBoolean';
import _merge from 'lodash/merge';
import auth from '@/lib/auth';
import { AJAX_LOADING, AJAX_ERROR } from '../../store/mutation-types';
import { instance } from '../api';

window.ajaxHeader = { token: null };

export function updateLoginInfo2({ token = null, userInfo }) {
  if (token) {
    if (window.ajaxHeader) {
      window.ajaxHeader.token = token;
      window.ajaxHeader.encUserId = userInfo ? userInfo.encUserId : null;
    } else {
      window.ajaxHeader = {
        token,
        encUserId: userInfo ? userInfo.encUserId : null
      };
    }
  }
  if (window.localStorage) {
    window.localStorage.setItem('token', token);
    if (userInfo) {
      window.localStorage.setItem('userinfo', JSON.stringify(userInfo));
    }
  }
}

// ajax middleware
function callApi(post = false, { commit }, api, params = {}, options = {}, showLoading = true, showError = true) {
  if (_isBoolean(params)) {
    showLoading = params;
    params = {};
  } else if (_isBoolean(options)) {
    showLoading = options;
    options = {};
  }
  if (showLoading) {
    commit(AJAX_LOADING, { loadingStatus: true });
  }
  // const token = window.localStorage.getItem('token');
  options = _merge({}, options, { headers: { token: window.ajaxHeader.token } });
  let respPromise = null;

  if (post) {
    respPromise = instance.post(api, params, options);
  } else {
    respPromise = instance.get(api, params, options);
  }

  return respPromise.then((resp) => {
    if (showLoading) {
      commit(AJAX_LOADING, { loadingStatus: false });
    }
    const { ok, problem, config: { url }, data } = resp;
    // let data = resp.data;
    const ajaxMobile = (url.indexOf('/mobile') !== -1);
    /**
     * 若需要处理非 0 状态下的异常逻辑，从promise的catch中的返回值 data !== null中根据特定code处理
     */
    if (ok) {
      if (ajaxMobile) {
        // apisause 默认将text转成成JSON
        // data = JSON.parse(resp.text);
        if (data.rescode && data.rescode.code !== '0') {
          if (showError) {
            commit(AJAX_ERROR, new Error(data.rescode.info));
          }
          if (data.rescode.code === '-100') {
            // 用户过期
            auth.clear(); 
            // auth.login('user');注释掉因为 第三方域名(baby tv)过期后自动登录url 不同
          }
          if (data.rescode.info == '该手机号已绑定' || data.rescode.info == '微信已绑定过其他手机') {
            // 用户过期
            auth.clear();
            setTimeout(() => {
              location.href = '//m.meitun.com/live/';
            }, 3000);
          }
          return Promise.reject(data);
        } else if (data.resultInfo && data.resultInfo.code !== 0) {
          if (showError) {
            commit(AJAX_ERROR, new Error(data.resultInfo.message));
          }
          return Promise.reject(data);
        }
      } else if (data.rtn_code !== '0') {
        if (showError) {
          commit(AJAX_ERROR, new Error(data.rtn_msg));
        }
        if (data.rtn_code === '0000002') {
          // 用户过期
          // auth.clear();
          // auth.login('user');
        }
        console.error(data, api, params);
        return Promise.reject(data);
      }
    } else {
      if (showError) {
        commit(AJAX_ERROR, new Error(problem));
      }
      /* eslint-disable new-cap */
      return Promise.reject(new Error(problem));
      /* eslint-enable */
    }
    // 这里返回的data为整个数据结构body，因为发现有的接口字段不完全都在data中，入freeList
    return data;
  });
  //   .catch((e) => {
  //   commit(AJAX_ERROR, e);
  //   return Promise.reject();
  // });
}
export function getApi(...args) {
  return callApi(false, ...args);
}

export function postApi(...args) {
  return callApi(true, ...args);
}

export default {
  get: getApi,
  post: postApi
};



// WEBPACK FOOTER //
// ./src/comm/middleware/callApi.js